<template>
    <div class="user-profile-tags-wrap mb-40px">
        <h2 class="mb-20px bg-gray fs-17 p-3 radius-4 d-flex align-center justify-content-between">Tags <router-link to="/tags" class="simple-text-btn">View all tags</router-link></h2>

        <ul class="tag-list">
            <li class="d-flex align-center justify-content-between" v-for="(item, i) in items" :key="i">
                <a class="tag" href="#">{{item.title}}</a>
                <div class="tag-stats d-flex align-center">
                    <span class="score">
                        <b>{{item.score}}</b> score
                    </span>
                    <span class="posts">
                        <b>{{item.posts}}</b> posts
                    </span>
                    <span class="posts-parcent" v-if="showPostParcent">
                        <b>{{item.parcent}}</b> posts %
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'UserProfileTags',
    props: ['items', 'showPostParcent']
}
</script>